import { SupplierCardType } from '@/components/v3/atoms/card/card'
import { GTM_EVENT } from '@/constants'
import { sendGTMEvent } from '@next/third-parties/google'

export const categoryImpressionGTMEvent = (
  listingId: number | string,
  supplierProfilePath: string,
  listingType: SupplierCardType
) => {
  sendGTMEvent({
    event: GTM_EVENT.CATEGORY_IMPRESSION,
    listing_id: String(listingId),
    supplier_profile_path: supplierProfilePath,
    listing_type: listingType,
  })
}
